import moment from "moment"
import { FC } from "react"
import {prevent} from "../../../core/utils/utils"
import RubbleIcon from "../../icons/RubbleIcon"

import styles from "../styles/Card.module.scss"
import {isNullOrUndefined} from "../../x-ui-core/utils"

interface ServiceCardProps {
  item: any
  selected: boolean
  onClick: (ev: any) => void
  onSelect: (service: any) => void
}

const ServiceCard: FC<ServiceCardProps> = ({
  item, selected, onClick, onSelect
}) => {

  const secsToTime = (secs: number) => {
    let mom = moment(secs * 1000).utcOffset('+0000', false)
    console.log(mom)
    return (secs / 60) >= 60 ? mom.format("H ч. mm мин.") : mom.format("mm мин.")
  }

  const getServicePrice = (serv: any) => {
    if (serv.price_max == 0) {
      if (!isNullOrUndefined(serv.staff) && serv.staff.length > 0) {
        return serv.staff[0].price.max
      } else {
        return 0
      }
    } else {
      return serv.price_max
    }
  }

  return (
    <>
      <div className={styles.card + (selected ? " " + styles.selected : "")}>
        <div className={styles.barber}>
          <div className={styles.b_avatar} style={{
            backgroundImage: `url(${item.image_group.images == undefined ? "" : item.image_group.images.basic.path})`
          }}></div>
          <div className={styles.b_data}>
            <div className={styles.b_data__named}>{item.title}</div>
          </div>
        </div>
        <div className={styles.trippler}>
          <div className={styles.t_block}>
            <div style={{marginBottom: "0px"}}>{getServicePrice(item)} <RubbleIcon /></div>
            <div>цена</div>
          </div>
          <div className={styles.t_block}>
            <div style={{fontSize: "14px"}}>{secsToTime(item.duration)}</div>
            <div>время</div>
          </div>
          <div className={styles.t_btn} onClick={(ev) => {
            prevent(ev)
            onSelect(item)
          }}>
            <span><i className="fas fa-plus"></i></span>
            <span><i className="fas fa-minus"></i></span>
          </div>
        </div>
      </div>
    </>
  )
}

export default ServiceCard